import { PropsWithChildren, useEffect, useState } from "react";
import { Sidebar } from "./sidebar";
import { MenuIcon } from "@heroicons/react/outline";
import { CurrentUser } from "./currentUser";
import { SidebarModal } from "./sidebarModal";
import { CurrencyButton } from "./currencyButton";
import LanguageGroup from "components/wps/LanguageGroup";
import { HttpError, useOne, useTranslation } from "@refinedev/core";
import { useLocation, useNavigate } from "react-router-dom";
import ExportModule from "components/wps/ExportModule";
import { canAccessByType } from "utills/helpers";
import { ITopBanner, UserType } from "interfaces";
import WPSTopBanner from "components/wps/WPSTopBanner";

export const DashBoardLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [menuOpen, setMenuOpen] = useState(true);
  const _toggleMenu = () => {
    setMenuOpen(!menuOpen);
  }
  const [type, setType] = useState('admin');
  const [permissions, setPermissions] = useState(null as any);
  const { translate } = useTranslation();
  const location = useLocation();
  const [token, setToken] = useState('');
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("USER") ?? "{}");
  const isWps = type === UserType.WPS;
  const isAdmin = type === UserType.ADMIN;
  const { data: topBannerData } = useOne<
    ITopBanner[] | { data?: ITopBanner[] },
    HttpError
  >({
    resource: "organization/banners/workspace",
    id: "",
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: isWps && !!userData?.token,
    } as any,
  });

  const topBannerPayload = topBannerData?.data;
  const topBanners = Array.isArray(topBannerPayload)
    ? topBannerPayload
    : topBannerPayload?.data ?? [];

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);
      setType(userData?.type || 'admin');

      if (userData?.type === 'wps') {
        const roles = [] as any;
        setToken(userData?.token);

        userData.permissions.forEach((item: any) => {
          const obj = {
            id: (item.resource !== "") ? item.resource : item.app,
            permissions: item.action,
            parrent: item.app
          };

          roles.push(obj);

          setPermissions(roles);

        });

        // Navgiate condition when login success
        if (user && (location.pathname === "/sign-in" || location.pathname === "/login")) {
          const dashboardRole = roles?.find(
            (r: { id: string; parrent: string; permissions: string[] }) => {
              return r.id === "dashboard";
            }
          );

          if (dashboardRole) {
            console.log("New WPS login & have dashboard permission!");
            
            navigate(`/${dashboardRole?.id}/overview`);
          } else {
            navigate(`/profile`);
          }
        }
      }
    }
  }, [location.pathname, navigate]);

  return (
    <div>
      {
        <SidebarModal
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          permissions={permissions}
          type={type}
        />
      }
      <Sidebar open={menuOpen} permissions={permissions} type={type} />

      {isWps && <WPSTopBanner banners={topBanners} menuOpen={menuOpen} />}

      {/* HEADER */}
      <div className={`w-100 min-h-screen bg-magnolia-500 flex flex-col transition-all duration-300 ${menuOpen ? "lg:pl-72" : "lg:pl-0"}`}>
        <div className="sticky top-0 z-[50] flex h-16 shrink-0 items-center border-b border-gray-200 bg-white shadow-sm gap-x-4 px-4 sm:gap-x-6 sm:px-4 lg:px-6">
          {/* Open Sidebar modal button */}
          <button
            type="button"
            className="text-brand-500 lg:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <MenuIcon className="h-6 w-6" aria-hidden="true" />
          </button>
          {/* Toggle menu button */}
          <button
            type="button"
            className="hidden text-brand-500 lg:block"
            onClick={_toggleMenu}
          >
            <span className="sr-only">Open sidebar</span>
            <MenuIcon className="h-6 w-6" aria-hidden="true" />
          </button>

          {/* Separator */}
          <div className="h-6 w-px bg-black/10 lg:hidden" aria-hidden="true" />

          <div className="gap-x-6 flex flex-1 items-center justify-end">
            {
              (token && token !== '') &&
              <ExportModule
                token={token}
                translate={translate} />
            }
            {
              isWps ?
                <LanguageGroup />
                :
                <CurrencyButton />
            }
            <CurrentUser />
          </div>
        </div>
        <main className="p-2 sm:p-4 w-full h-full flex-1 flex justify-center">
          {(isWps || (isAdmin && canAccessByType(UserType.ADMIN))) ? (
            <div className="w-full">
              {children}
            </div>
          ) : <></>}
        </main>
      </div>
    </div>
  )
};
